/* before.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./before.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { fg } from '@atlaskit/platform-feature-flags';
var beforeElementStyles = null;

// To be removed with platform-component-visual-refresh (BLU-2992)
var beforeElementStylesOld = null;
var Before = function Before(_ref) {
  var elemBefore = _ref.elemBefore;
  return elemBefore ? /*#__PURE__*/React.createElement("span", {
    className: ax([fg('platform-component-visual-refresh') ? "_1e0c1txw _4t3i7vkz _4cvr1h6o _1bah1h6o _152tze3t" : "_2rko1l5z _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _152tze3t"])
  }, elemBefore) : null;
};

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export default Before;